import axios from 'axios'
import { Message } from 'element-ui'
import config from '@/config'
import router from "../router";

// 防止重复提示的标记
let isShowingMessage = false
let messageTimer = null
// 显示错误消息（防重复）
const showErrorMessage = (message, type = 'error') => {
  if (isShowingMessage) return

  isShowingMessage = true
  clearTimeout(messageTimer)

  messageTimer = setTimeout(() => {
    Message({
      message: message,
      type: type,
      duration: 3000,
      onClose: () => {
        isShowingMessage = false
      }
    })
  }, 1000)
}

const service = axios.create({
  baseURL: config.baseApi,
  timeout: config.timeout,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
  }
})

service.interceptors.request.use(
  config => {
    const path = router.currentRoute && router.currentRoute.path
    const isAdmin = path && path.startsWith('/admin') && path !== '/admin/login'
    if (isAdmin) {
      const token = localStorage.getItem('admin_token')
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // 成功响应
    if (res.success) {
      return res
    }
    // 业务错误
    showErrorMessage(res.message || '请求失败')
    // 返回更完整的错误信息
    const error = new Error(res.message || '请求失败')
    error.code = res.code // 保留错误码
    error.data = res.data // 保留原始数据
    return Promise.reject(error)
  },
  error => {
    // 网络错误或 HTTP 错误
    if (error.response) {
      // 处理 401
      if (error.response.status === 401) {
        // 防止重复跳转
        if (!window._isRedirecting) {
          window._isRedirecting = true
          showErrorMessage('登录已过期，请重新登录')

          localStorage.removeItem('admin_token')
          setTimeout(() => {
            router.push('/admin/login')
            window._isRedirecting = false
          }, 500)
        }
        return Promise.reject(error)
      }
      // 其他 HTTP 状态码
      const statusMap = {
        400: '请求参数错误',
        403: '无权限访问',
        404: '请求资源不存在',
        500: '服务器内部错误',
        502: '网关错误',
        503: '服务不可用',
        504: '网关超时'
      }

      const message = statusMap[error.response.status] || '请求失败，请重试'
      showErrorMessage(message)
    }else if (error.code === 'ECONNABORTED') {
      // 请求超时
      showErrorMessage('请求超时，请检查网络')
    } else {
      // 网络断开等其他错误
      showErrorMessage('网络异常，请检查连接')
    }

    return Promise.reject(error)
  }
)

export default service
